require('./bootstrap');
require('slick-carousel');
require('./galago');
